import React, { useCallback, useEffect, useState } from 'react';
import { AutoLink, useApp } from 'react-admin-base';
import { useIsMobile, useTheme } from 'react-admin-base-bootstrap';
import { Link, useMatch } from "react-router-dom";
import { useGlobalMenuState } from '../../Providers/GlobalMenuStateProvider';
export function ThemeSwitcherButton() {
    const [theme, setTheme] = useTheme();
    const toggleTheme = useCallback(function (e) {
        setTheme(theme === "dark" ? "light" : "dark");
    }, [theme, setTheme]);
    return React.createElement("button", { type: "button", className: "btn btn-ghost-secondary", onClick: toggleTheme },
        React.createElement("i", { className: theme === "dark" ? "bi-brightness-high" : "bi-moon" }));
}
export function Logo() {
    const app = useApp();
    return React.createElement(Link, { to: "/", className: "logo" },
        app.logo && React.createElement("span", { className: "logo-lg" },
            React.createElement("img", { className: "navbar-brand-logo", src: app.logo, alt: app.name })),
        app.onlylogo && React.createElement("span", { className: "logo-sm" },
            React.createElement("img", { className: "navbar-brand-logo-mini", src: app.onlylogo, alt: app.name })),
        !app.logo && React.createElement("span", { className: "logo-lg" },
            React.createElement("span", { className: "text-white", style: { fontSize: '1.75em' } }, app.name)),
        !app.logo && React.createElement("span", { className: "logo-sm" },
            React.createElement("span", { className: "text-white", style: { fontSize: '1.75em' } }, app.name[0])));
}
export default function Sidebar({ children }) {
    const _isMobile = useIsMobile();
    const [menuOpen, toggleMenu] = useGlobalMenuState();
    useEffect(function () {
        if (menuOpen) {
            document.body.setAttribute('data-sidebar', 'dark');
            document.body.className = "";
        }
        else {
            document.body.setAttribute('data-sidebar', 'dark');
            document.body.className = "sidebar-enable " + (!_isMobile ? " vertical-collpsed" : "");
        }
    }, [_isMobile, menuOpen]);
    return React.createElement("div", { className: "vertical-menu mm-active" },
        React.createElement("div", { id: "sidebar-menu" },
            React.createElement("ul", { className: "metismenu list-unstyled mm-show" }, children)));
}
export function MenuGroup({ title, children }) {
    return React.createElement(React.Fragment, null,
        React.createElement("li", { className: "menu-title" }, title),
        children);
}
export function Menu({ icon, to, title, children, defaultOpen }) {
    const match = useMatch(to);
    const [isOpen, setIsOpen] = useState(defaultOpen || (to && match ? true : false));
    const isReallyOpen = match || isOpen;
    const toggleMenu = useCallback(function (e) {
        if (children) {
            e.preventDefault();
            setIsOpen(!isOpen);
        }
    }, [isOpen]);
    const link = React.createElement(AutoLink, { to: to || '', onClick: toggleMenu, className: "waves-effect" + (children ? " dropdown-toggle has-arrow" : "") + (!isReallyOpen ? ' collapsed' : '') + (to && match ? ' active' : ''), "aria-expanded": !children ? null : isReallyOpen ? 'true' : 'false', "data-toggle": (children ? 'collapse' : '') },
        icon && React.createElement("i", { className: icon + ' me-2' }),
        React.createElement("span", null, title));
    return React.createElement("li", { className: children && isOpen ? "mm-active" : "" },
        link,
        children && isOpen ? React.createElement("ul", { className: "sub-menu mm-collapse mm-show" }, children) : null);
}
